export default "__VITE_ASSET__QCmzIz$T__"